
import BalanceOfAbi from '../utils/BalanceOfAbi.json';
import RouterContract from "../utils/CreateTokenAbi.json"
import TradePoolAbi from '../utils/TradePoolAbi.json'
import FactoryContractAbi from '../utils/FactoryContractAbi.json'
import PairContractAbi from '../utils/PairContractAbi.json'
import UniSwapAbi from '../utils/UniswapAbi.json'
import WETHTokenAbi from '../utils/WETHTokenAbi.json'
import RockRelayerAbi from '../utils/RockRelayerAbi.json'
import web3NoAccount from './web3';

const getContract = (abi, address, web3) => {
    const _web3 = web3 ?? web3NoAccount;
    return new _web3.eth.Contract(abi, address);
};

export const getBalance = (address, web3) => {
    return getContract(BalanceOfAbi, address, web3);
};

export const rockBalance = (address, web3) => {
    return getContract(BalanceOfAbi, address, web3);
};
export const getToken = (address, web3) => {
    return getContract(RouterContract, address, web3);
};

export const getTrade = (address, web3) => {
    return getContract(TradePoolAbi, address, web3);
};

export const getFactoryContract = (address, web3) => {
    return getContract(FactoryContractAbi, address, web3);
}

export const getPairAddressContract = async (contractAddress, web3) => {
    return getContract(PairContractAbi, contractAddress, web3);
}

export const getUniSwapContract = async (contractAddress, web3) => {
    return getContract(UniSwapAbi, contractAddress, web3);
}

export const getwETHContract = async (contractAddress, web3) => {
    return getContract(WETHTokenAbi, contractAddress, web3);
}

export const getRockRelayerContract = async (contractAddress, web3) => {
    return getContract(RockRelayerAbi, contractAddress, web3);
}
